import { Component } from '@verndale/core';

class RelatedPatientStories extends Component {
  page: number = 0;
  cardsLength: number = 0;
  itemsPerPage: number = 6;

  constructor(el: HTMLElement) {
    super(el);
    this.cardsLength = (this.dom.cards as NodeListOf<HTMLButtonElement>).length || 0;

    if (this.cardsLength === 0) {
      (this.dom.showMoreBtn as HTMLElement).style.display = 'none';
    }
  }

  setupDefaults() {
    this.dom = {
      featuredCardsContainer: this.el.querySelector<HTMLElement>(
        '.featured-articles__cards-container'
      ),
      showMoreBtn: this.el.querySelector<HTMLElement>('.featured-articles__show-more-btn'),
      cards: this.el.querySelectorAll('.article-card') as NodeListOf<HTMLButtonElement>
    };
  }

  addListeners() {
    (this.dom.showMoreBtn as HTMLButtonElement)?.addEventListener(
      'click',
      this.showMore.bind(this)
    );
  }

  showMore(e: Event) {
    const showMoreButton = e.target as HTMLElement;
    const cards = this.el.querySelectorAll('.article-card') as NodeListOf<HTMLButtonElement>;

    (this.dom.featuredCardsContainer as HTMLElement).style.display = 'grid';

    this.page++;

    if (this.page * this.itemsPerPage >= this.cardsLength) {
      showMoreButton.style.display = 'none';
    }

    for (let i = 0; i < this.page * this.itemsPerPage; i++) {
      if (cards[i]) {
        cards[i].classList.add('article-card--visible');
      }
    }
  }
}

export default RelatedPatientStories;
